// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"326":"dbeb3035","406":"b2cfea23","956":"448127d1"}[chunkId] + ".chunk.js";
};